import { combineReducers } from 'redux';
import layoutReducer from './layout/layoutState';
import modalReducer from './modal/modalState';
import authReducer from './auth/authState';
import crudReducer from './crud/crudState';
import chatReducer from './chat/chatState';
import moduleReducer from './module/moduleState';
import userReducer from './user/userState';
import accessRightReducer from './accessright/accessRightState';
import parameterReducer from './parameter/parameterState';
import roleReducer from './role/roleState';
import userRoleReducer from './userrole/userRoleState';
import userDetailsReducer from './userdetails/userDetailsState';
import psgcDataReducer from './psgcdata/psgcDataState';
import dynamicListReducer from './dynamiclist/dynamicListState';
import dashboardReducer from './dashboard/dashboardState';
import accountReducer from './account/accountState';
import farmAnimalReducer from './farmanimal/farmAnimalState';
import breedingEventReducer from './breedingevent/breedingEventState';
import employeeReducer from './employee/employeeState';
import farmReducer from './farm/farmState';

const rootReducer = combineReducers({
  layout: layoutReducer,
  modal: modalReducer,
  auth: authReducer,
  crud: crudReducer,
  chat: chatReducer,
  module: moduleReducer,
  user: userReducer, 
  accessRight: accessRightReducer, 
  parameter: parameterReducer,
  role: roleReducer,
  userRole: userRoleReducer,
  userDetails: userDetailsReducer,
  farmAnimal: farmAnimalReducer,
  psgcData: psgcDataReducer,
  dynamicList: dynamicListReducer,
  dashboard: dashboardReducer,
  account: accountReducer,
  breedingEvent: breedingEventReducer,
  employee:employeeReducer,
  farm: farmReducer,
});

export default rootReducer;


